import styled from "styled-components"
import { CONFIDENCE_LOW, CONFIDENCE_MEDIUM, CONFIDENCE_HIGH } from "const"
import {
    Container,
    PageForm,
} from "client/components"
import { ConfidenceType } from "client/utils/types"

export const ObjectiveLayout = styled.div`
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    background: ${(props) => props.theme.pageLayoutBackground};
`
export const ObjectiveForm = styled(PageForm)`
    margin-bottom: 15px;
    background: ${(props) => props.theme.pageContentBackground};
`
export const ObjectiveCommentListWrapper = styled(Container)`
    background: ${(props) => props.theme.pageContentBackground};
`
export const KeyResultWrapper = styled(Container)`
    margin-bottom: 15px;
    height: fit-content;
    background: ${(props) => props.theme.pageContentBackground};
`
export const KeyResultLayout = styled.div`
    display: flex;
    flex-direction: row;
    flex-grow: 1;
    background: ${(props) => props.theme.pageLayoutBackground};
`

const graphColumnWidth = "580px"
const graphColumnMargin = "15px"

export const KeyResultBodyColumn = styled.div`
    display: flex;
    flex-direction: column;
    width: calc(100% - ${graphColumnWidth} - ${graphColumnMargin});
`
export const KeyResultGraphColumn = styled.div`
    display: flex;
    flex-direction: column;
    width: ${graphColumnWidth};
    margin-left: ${graphColumnMargin};
`
export const KeyResultForm = styled(PageForm)`
    margin-bottom: 15px;
    background: ${(props) => props.theme.pageContentBackground};
`
export const KeyResultCommentListWrapper = styled(Container)`
    background: ${(props) => props.theme.pageContentBackground};
`
export const OwnerList = styled.div`
    & > div {
        float: left;
        padding: 5px 12px 5px 6px;
        margin-right: 8px;
        margin-bottom: 5px;
        border-radius: 20px;
        background: ${(props) => props.theme.inputBackground};
    }
`
export const Confidence = styled.div<{
    confidenceLevel: ConfidenceType
}>`
    width: fit-content;
    padding: 2px 4px;
    margin: 6px 0;
    border-radius: 2px;
    font-size: 11px;
    font-weight: 600;
    text-transform: uppercase;
    font-family: ${(props) => props.theme.openSans};
    color: ${(props) => props.theme.defaultTextColor};
    background: ${(props) => {
        if (props.confidenceLevel === CONFIDENCE_LOW) return props.theme.confidenceLowBackground
        if (props.confidenceLevel === CONFIDENCE_MEDIUM) return props.theme.confidenceMediumBackground
        if (props.confidenceLevel === CONFIDENCE_HIGH) return props.theme.confidenceHighBackground
        return "none"
    }};
`
export const ProgressPercents = styled.div<{
    percents: number
}>`
    color: ${(props) => {
        if (props.percents < 20) return props.theme.keyResultUpdatePercentsSummColor20
        if (props.percents < 40) return props.theme.keyResultUpdatePercentsSummColor40
        if (props.percents < 70) return props.theme.keyResultUpdatePercentsSummColor70
        if (props.percents <= 100) return props.theme.keyResultUpdatePercentsSummColor100
        return props.theme.keyResultUpdatePercentsSummColor
    }};
`
